import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AvisRevision } from '../../../../models/avisRevision';

interface HistoLigne {
  ancienneRef: string;
  nouvelleRef: string;
  dateHeure: Date;
}

@Component({
  selector: 'app-histo-ref-consult-modal',
  templateUrl: './histo-ref-consult-modal.component.html',
  styleUrls: ['./histo-ref-consult-modal.component.scss']
})
export class HistoRefConsultModalComponent {

  @Input() set revisions(data: AvisRevision[]) {
    const sorted = [...data].sort((a, b) => a.revisionNumber - b.revisionNumber);
    // On ignore la première révision (valeur d'origine), on n'affiche que les changements
    this.lignes = sorted.slice(1).map((rev, index) => ({
      ancienneRef: sorted[index].refConsultation || '-',
      nouvelleRef: rev.refConsultation || '-',
      dateHeure: rev.dateHeure
    }));
  }

  public lignes: HistoLigne[] = [];

  constructor(public activeModal: NgbActiveModal) {}
}
